import React from 'react';

import * as S from './styles';

function ArrowG() {
  return <S.IoArrow />;
}

export default ArrowG;